"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable: variable-name no-shadowed-variable */
var numerics_1 = require("../numerics");
var T_t = 273.16; // [K]
var p_t = 0.000611657 * 1000 * 1000; // [MPa] -> [Pa]
var p_0 = 0.101325 * 1000 * 1000; // [MPa] -> [Pa]
var M06 = 18.015268 / 1000; // [kg/kmol] -> [kg/mol]
var g00 = -0.632020233449497E6;
var g01 = 0.655022213658955;
var g02 = -0.189369929326131e-7;
var g03 = 0.339746123271053e-14;
var g04 = -0.556464869058991e-21;
var s0 = -0.332733756492168E4;
var t1 = numerics_1.Complex.create(0.368017112855051E-1, 0.510878114959572E-1);
var t2 = numerics_1.Complex.create(0.337315741065416, 0.335449415919309);
var t = [numerics_1.Complex.create(0, 0), t1, t2];
var r1 = numerics_1.Complex.create(0.447050716285388E2, 0.656876847463481E2);
var r20 = numerics_1.Complex.create(-0.725974574329220E2, -0.781008427112870E2);
var r21 = numerics_1.Complex.create(-0.557107698030123e-4, 0.464578634580806e-4);
var r22 = numerics_1.Complex.create(0.234801409215913e-10, -0.285651142904972e-10);
/// <param name="p">Pressure [Pa]</param>
/// <param name="T">Temperature [K] </param>
/// <returns>[J/kg]</returns>
function Get_Specific_Enthalpy_of_Ice(p, T) {
    var g = Get_g(p, T);
    var dg_dT = Get_dg_dT(p, T);
    var h_ice = g - T * dg_dT;
    return h_ice;
}
exports.Get_Specific_Enthalpy_of_Ice = Get_Specific_Enthalpy_of_Ice;
/// <param name="p">Pressure [Pa]</param>
/// <param name="T">Temperature [K]</param>
/// <returns>Specific Volume [m3/kg_a]</returns>
function Get_Specific_Volume_of_Ice(p, T) {
    return Get_dg_dp(p, T);
}
exports.Get_Specific_Volume_of_Ice = Get_Specific_Volume_of_Ice;
/// <param name="p">Pressure [Pa]</param>
/// <param name="T">Temperature [K]</param>
/// <returns>Molar Volume [kg/mol]</returns>
function Get_Molar_volume_of_Ice(p, T) {
    var vbar_ws = M06 * Get_Specific_Volume_of_Ice(p, T);
    return vbar_ws;
}
exports.Get_Molar_volume_of_Ice = Get_Molar_volume_of_Ice;
/// <param name="p">Pressure [Pa]</param>
/// <param name="T">Temperature [K]</param>
/// <returns>Isothermal_Compressibility [1/Pa]</returns>
function Get_Isothermal_Compressibility_of_Ice(p, T) {
    var dg_dp = Get_dg_dp(p, T);
    var dg2_dp2 = Get_d2g_dp2(p, T);
    var result = -dg2_dp2 / dg_dp;
    return result;
}
exports.Get_Isothermal_Compressibility_of_Ice = Get_Isothermal_Compressibility_of_Ice;
/// <param name="p">Pressure [Pa]</param>
/// <param name="T">Temperature [K]</param>
/// <returns></returns>
function Get_g(p, T) {
    var pi = p / p_t;
    var pi_0 = p_0 / p_t;
    var r2 = numerics_1.Complex.add(r20, numerics_1.Complex.add(numerics_1.Complex.multiply(r21, (pi - pi_0)), numerics_1.Complex.multiply(r22, Math.pow((pi - pi_0), 2))));
    var g0 = g00 + g01 * (pi - pi_0) + g02 * Math.pow((pi - pi_0), 2) + g03 * Math.pow((pi - pi_0), 3) + g04 * Math.pow((pi - pi_0), 4);
    var r = [
        numerics_1.Complex.create(0, 0),
        r1,
        r2,
    ];
    var theta = T / T_t;
    var sum = numerics_1.Complex.create(0, 0);
    for (var k = 1; k <= 2; k++) {
        sum = numerics_1.Complex.add(sum, numerics_1.Complex.multiply(r[k], numerics_1.Complex.subtract(numerics_1.Complex.subtract(numerics_1.Complex.add(numerics_1.Complex.multiply(numerics_1.Complex.subtract(t[k], theta), numerics_1.Complex.log(numerics_1.Complex.subtract(t[k], theta))), numerics_1.Complex.multiply(numerics_1.Complex.add(t[k], theta), numerics_1.Complex.log(numerics_1.Complex.add(t[k], theta)))), numerics_1.Complex.multiply(numerics_1.Complex.multiply(2, t[k]), numerics_1.Complex.log(t[k]))), numerics_1.Complex.divide(Math.pow(theta, 2), t[k]))));
    }
    var g = g0 - s0 * T_t * theta + T_t * sum.real;
    return g;
}
/// <param name="p">Pressure [Pa]</param>
/// <param name="T">Temperature [K]</param>
/// <returns></returns>
function Get_dg_dT(p, T) {
    var pi = p / p_t;
    var pi_0 = p_0 / p_t;
    var r2 = numerics_1.Complex.add(numerics_1.Complex.add(r20, numerics_1.Complex.multiply(r21, (pi - pi_0))), numerics_1.Complex.multiply(r22, Math.pow((pi - pi_0), 2)));
    var r = [numerics_1.Complex.create(0, 0), r1, r2];
    var theta = T / T_t;
    var sum = numerics_1.Complex.create(0, 0);
    for (var k = 1; k <= 2; k++) {
        sum = numerics_1.Complex.add(sum, numerics_1.Complex.multiply(r[k], numerics_1.Complex.subtract(numerics_1.Complex.add(numerics_1.Complex.multiply(-1, numerics_1.Complex.log(numerics_1.Complex.subtract(t[k], theta))), numerics_1.Complex.log(numerics_1.Complex.add(t[k], theta))), numerics_1.Complex.divide(numerics_1.Complex.multiply(2, theta), t[k]))));
    }
    var dg_dT = -s0 + sum.real;
    return dg_dT;
}
/// <param name="p">Pressure [Pa]</param>
/// <param name="T">Temperature [K]</param>
/// <returns></returns>
function Get_dg_dp(p, T) {
    var theta = T / T_t;
    var pi = p / p_t;
    var pi_0 = p_0 / p_t;
    // Calculate dg_dp
    var g0_p = g01 * 1.0 / p_t * Math.pow(pi - pi_0, 1 - 1.0) + g02 * 2.0 / p_t * Math.pow(pi - pi_0, 2 - 1.0) +
        g03 * 3.0 / p_t * Math.pow(pi - pi_0, 3 - 1.0) +
        g04 * 4.0 / p_t * Math.pow(pi - pi_0, 4 - 1.0);
    var r2_p = numerics_1.Complex.add(numerics_1.Complex.multiply(numerics_1.Complex.divide(numerics_1.Complex.multiply(r21, 1.0), p_t), Math.pow(pi - pi_0, 1 - 1.0)), numerics_1.Complex.multiply(r22, numerics_1.Complex.multiply(numerics_1.Complex.divide(2.0, p_t), Math.pow(pi - pi_0, 2 - 1.0))));
    var dg_dp = g0_p + T_t * numerics_1.Complex.multiply(r2_p, numerics_1.Complex.add(numerics_1.Complex.multiply(numerics_1.Complex.subtract(t2, theta), numerics_1.Complex.log(numerics_1.Complex.subtract(t2, theta))), numerics_1.Complex.subtract(numerics_1.Complex.subtract(numerics_1.Complex.multiply(numerics_1.Complex.add(t2, theta), numerics_1.Complex.log(numerics_1.Complex.add(t2, theta))), numerics_1.Complex.multiply(2.0, numerics_1.Complex.multiply(t2, numerics_1.Complex.log(t2)))), numerics_1.Complex.divide(theta * theta, t2)))).real;
    return dg_dp;
}
/// <param name="p">Pressure [Pa]</param>
/// <param name="T">Temperature [K]</param>
/// <returns></returns>
function Get_d2g_dp2(p, T) {
    var theta = T / T_t;
    var pi = p / p_t;
    var pi_0 = p_0 / p_t;
    // Calculate dg2_dp2
    var g0_pp = g02 * 2.0 * (2.0 - 1.0) / p_t / p_t * Math.pow(pi - pi_0, 2.0 - 2.0) +
        g03 * 3.0 * (3.0 - 1.0) / p_t / p_t * Math.pow(pi - pi_0, 3.0 - 2.0) +
        g04 * 4.0 * (4.0 - 1.0) / p_t / p_t * Math.pow(pi - pi_0, 4 - 2.0);
    var r2_pp = numerics_1.Complex.multiply(r22, 2.0 / p_t / p_t);
    var d2g_dp2 = g0_pp + T_t * numerics_1.Complex.multiply(r2_pp, numerics_1.Complex.add(numerics_1.Complex.multiply(numerics_1.Complex.subtract(t2, theta), numerics_1.Complex.log(numerics_1.Complex.subtract(t2, theta))), numerics_1.Complex.subtract(numerics_1.Complex.subtract(numerics_1.Complex.multiply(numerics_1.Complex.add(t2, theta), numerics_1.Complex.log(numerics_1.Complex.add(t2, theta))), numerics_1.Complex.multiply(2.0, numerics_1.Complex.multiply(t2, numerics_1.Complex.log(t2)))), numerics_1.Complex.divide(theta * theta, t2)))).real;
    return d2g_dp2;
}
